/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const phoneErrorResponseMessageMax = 300;

export const phoneErrorResponseCorrelationIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);

export const PhoneErrorResponse = zod.object({
  code: zod.enum([
    'AUTHORITY_INVALID',
    'NOT_READY',
    'PRIORITY_FIELD_REQUIRED',
    'INTEGRATION_RETIRED',
    'INTEGRATION_NOT_RETIRED',
    'PAYLOAD_TOO_LARGE',
    'INTERNAL_ERROR',
    'INVALID_REQUEST',
    'SESSION_REQUIRED',
    'CAPABILITY_DENIED',
    'EMPLOYEE_REQUIRED',
    'NOT_FOUND',
    'VERSION_CONFLICT',
    'TEAM_NAME_EXISTS',
    'CUSTOMER_NAME_EXISTS',
    'INELIGIBLE_PARTICIPANT',
    'SCHEDULE_NAME_EXISTS',
    'ROUTINE_NAME_EXISTS',
    'SECTION_OVERLAP',
    'CONFIRMATION_REQUIRED',
    'OVERRIDE_OVERLAP',
    'SCHEDULE_ARCHIVED',
    'CUSTOMER_ARCHIVED',
    'CUSTOMER_ASSIGNMENTS_BLOCK_ARCHIVE',
    'CUSTOMER_DELETE_BLOCKED',
    'ASSIGNMENT_EXISTS',
    'TEAM_INACTIVE',
    'KNOWN_NUMBER_EXISTS',
    'INVALID_PHONE_NUMBER',
    'PHONE_NUMBER_EXISTS',
    'CLIENT_CODE_EXISTS',
    'CLIENT_CODE_EXHAUSTED',
    'INVALID_AUDIO',
    'WRITE_UNCERTAIN',
    'CUSTOMER_AUDIT_POLICY_UNAVAILABLE',
    'CUSTOMER_ACTIVITY_UNAVAILABLE',
    'DEPENDENCY_BLOCKED',
    'LAST_ACTIVE_ADMIN',
    'ROLE_DEPENDENCY',
    'IDEMPOTENCY_CONFLICT',
    'VERIFICATION_UNAVAILABLE',
    'UNSUPPORTED_VERIFICATION_DESTINATION',
    'CONTACT_EXISTS',
    'CONTACT_NOT_VERIFIED',
    'RATE_LIMITED',
    'IDENTITY_UNAVAILABLE',
    'DIRECTORY_UNAVAILABLE',
    'STORAGE_UNAVAILABLE',
    'DEPENDENCY_UNAVAILABLE',
    'FEATURE_UNAVAILABLE',
  ]),
  message: zod.string().min(1).max(phoneErrorResponseMessageMax),
  correlationId: zod.uuid().regex(phoneErrorResponseCorrelationIdRegExp),
  fieldErrors: zod
    .record(
      zod.string(),
      zod.enum([
        'Invalid value.',
        'Value is out of range.',
        'Value is already in use.',
        'Unsupported field.',
      ]),
    )
    .optional(),
});

export type PhoneErrorResponse = zod.input<typeof PhoneErrorResponse>;
export type PhoneErrorResponseOutput = zod.output<typeof PhoneErrorResponse>;
